import React from "react";
import styles from "./style.module.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Title from "../../components/Title";
import CatalogCard from "../../components/CatalogCard";
import useScrollToTop from "../../helpers/useScrollToTop";
const _catalogData = [
  {
    img: require("./assets/ukladka.jpg"),
    title: "Укладка тротуарной плитки",
    navigateTo: "ukladka",
  },
  {
    img: require("./assets/kovka.jpg"),
    title: "Художественная ковка",
    navigateTo: "kovka",
  },
  {
    img: require("./assets/dostavka.jpg"),
    title: "Доставка материалов",
    navigateTo: "dostakva",
  },
  {
    img: require("./assets/drenaj.jpeg"),
    title: "Лоток водоотводный",
    navigateTo: "drenaj",
  },
  {
    img: require("./assets/blagoustroistva.jpeg"),
    title: "Благоустройство территори",
    navigateTo: "blagoustroistvo",
  },
];
export default function Services() {
  useScrollToTop();
  return (
    <div>
      <Header />
      <div className={styles.main}>
        <Title text="Услуги" />
        <div className={styles.catalogContainer}>
          {_catalogData.map((item, index) => (
            <CatalogCard
              key={index}
              image={item.img}
              title={item.title}
              navigateTo={item.navigateTo}
            />
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
}
